import(/* webpackMode: "eager" */ "/opt/nextjs/src/app/error.tsx");
